export default {"src":"/_next/static/media/find_on_banquet.c4e2d7b2.svg","height":100,"width":400,"blurWidth":0,"blurHeight":0};